const stickyManager = {};
stickyManager.elements = [
  {
    el: '.section-header',
    order: 1,
    visibleOnScrollDown: false,
    visibleOnScrollUp: true,
  },
  {
    el: '#announcementBar',
    order: 0,
    visibleOnScrollDown: true,
    visibleOnScrollUp: true
  },
  {
    el: '.mobileProductSticky',
    order: 2,
    visibleOnScrollDown: true,
    visibleOnScrollUp: false
  },
  {
    el: '.stickyUpsellDesktop',
    order: 3,
    visibleOnScrollDown: true,
    visibleOnScrollUp: true
  }
]
stickyManager.elements.sort((a, b) => a.order - b.order);

function setStickyPositions(hidingElement) {
  let lastElementPosition = 0;

  stickyManager.elements.forEach((node, i) => {
    let element = document.querySelector(node.el)
  
    if(element !== null && element.offsetParent == null ) {
      document.querySelectorAll(node.el).forEach(el => {
        if(el.offsetParent !== null) {
          element = el
        }
      })
    }
    if(element !== null) {
      element.style.position = 'sticky';
      element.style.transition = 'transform .3s ease, opacity .3s ease';
      
      if(element  ) {
        element.style.top = `${lastElementPosition}px`;
      }

      element.style.zIndex = stickyManager.elements.length*100 - i;
      // console.log(window.scrollY + lastElementPosition, element.offsetTop)
      if(hidingElement === element && hidingElement !== undefined ) {
        lastElementPosition = lastElementPosition; 
      }else {
        lastElementPosition = element.offsetHeight + lastElementPosition;
      }

    }
  })
}
setStickyPositions()

function handleScrollDownVisibility(scrollPosition) {

  stickyManager.elements.forEach((node, i) => {
    let element = document.querySelector(node.el)
  
    if(element !== null && element.offsetParent == null) {
      document.querySelectorAll(node.el).forEach(el => {
        if(el.offsetParent !== null) {
          element = el
        }
      })
    }
    let visibility = node.visibleOnScrollDown;

    if(element !== null && scrollPosition + 30 >= element.offsetHeight) {
      // console.log(scrollPosition, element.offsetHeight)
      if(visibility === false ) {
        element.style.transform = 'translateY(-300%)';
        element.style.opacity = '0';
  
        setStickyPositions(element)
        return;
      }
      if(visibility === true) {
        element.style.transform = ''
        element.style.opacity = '1';
        return;
      }
    }
  })
}
function handleScrollUpVisibility(scrollPosition) {
  stickyManager.elements.forEach((node, i) => {
    let element = document.querySelector(node.el)
  
    if(element !== null && element.offsetParent == null) {
      document.querySelectorAll(node.el).forEach(el => {
        if(el.offsetParent !== null) {
          element = el
        }
      })
    }
    let visibility = node.visibleOnScrollUp;

    if(element !== null) {
      if(visibility === false) {
        // element.style.position = 'fixed'
        element.style.transition = 'transform .3s ease, opacity .3s ease, top 0s .6s ease-out';
        element.style.transform = 'translateY(-300%)';

        element.style.opacity = '0';
        setStickyPositions(element)

      }
      if(visibility === true) {      
        element.style.transform = ''
        element.style.opacity = '1';
        setStickyPositions()
      }
    }
  })
}

function handleScroller() {
  const scrollPosition = window.scrollY;
  const scrollThreshold = 30; // Adjust this threshold as needed
  // Check if the scroll position has changed significantly
  if (Math.abs(scrollPosition - lastScrollPosition) >= scrollThreshold) {
    // console.log(scrollPosition)
    if(scrollPosition > lastScrollPosition) {
      handleScrollDownVisibility(scrollPosition)
      // console.log('going down')
    }else{
      handleScrollUpVisibility(scrollPosition)
      // console.log('going up')
    }
    
    lastScrollPosition = scrollPosition;
  }

  // Schedule the next frame
  // requestAnimationFrame(handleScroller);
}

let lastScrollPosition = 0;

document.addEventListener('scroll', function(){
  requestAnimationFrame(handleScroller)
})
// requestAnimationFrame(handleScroller);